if (!customElements.get('double-carousel')) {
  class TG_ComponentDoubleCarousel extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {

      this.element = this;
  
      this.textCarouselElement = this.element.querySelector('.DoubleCarousel__First');
      this.imageCarouselElement = this.element.querySelector('.DoubleCarousel__Second');

      if (this.textCarouselElement) {
        this.textCarousel = new themegoal.components.Carousel(this.textCarouselElement, { onSelect: this._onTextChanged.bind(this) });
      }

      if (this.imageCarouselElement) {
        this.imageCarousel = new themegoal.components.Carousel(this.imageCarouselElement, { onSelect: this._onImageChanged.bind(this) });
      }

    }

    disconnectedCallback(){
      if(this.textCarousel)this.textCarousel.destroy();
      if(this.imageCarousel)this.imageCarousel.destroy();
    }

    _onTextChanged(element) {
      if(this.imageCarousel.getSelectedIndex() != this.textCarousel.getSelectedIndex())
      this.imageCarousel.selectCell(this.textCarousel.getSelectedIndex())
    }

    _onImageChanged(element) {
      if(this.imageCarousel.getSelectedIndex() != this.textCarousel.getSelectedIndex())
      this.textCarousel.selectCell(this.imageCarousel.getSelectedIndex())
    }
    
  }
          
  customElements.define('double-carousel', TG_ComponentDoubleCarousel);
}